var _mask, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_117_2591",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_117_2591_clip_path)",
    "data-figma-skip-parse": "true",
    mask: "url(#path-1-inside-1_117_2591)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.021 -0.021 0 21 21)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1285.71,
    y: -1285.71,
    width: 2571.43,
    height: 2571.43
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(0, 170, 99, 1) 0deg,rgba(47, 48, 55, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 21H36C36 29.2843 29.2843 36 21 36V42V48C35.9117 48 48 35.9117 48 21H42ZM21 42V36C12.7157 36 6 29.2843 6 21H0H-6C-6 35.9117 6.08831 48 21 48V42ZM0 21H6C6 12.7157 12.7157 6 21 6V0V-6C6.08831 -6 -6 6.08831 -6 21H0ZM21 0V6C29.2843 6 36 12.7157 36 21H42H48C48 6.08831 35.9117 -6 21 -6V0Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.0,\"g\":0.66666668653488159,\"b\":0.38823530077934265,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.18431372940540314,\"g\":0.18823529779911041,\"b\":0.21568627655506134,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.0,\"g\":0.66666668653488159,\"b\":0.38823530077934265,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.18431372940540314,\"g\":0.18823529779911041,\"b\":0.21568627655506134,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":2.5717584698381913e-15,\"m01\":-42.0,\"m02\":42.0,\"m10\":42.0,\"m11\":2.5717584698381913e-15,\"m12\":-2.5717584698381913e-15},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#path-1-inside-1_117_2591)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_117_2591_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 21H36C36 29.2843 29.2843 36 21 36V42V48C35.9117 48 48 35.9117 48 21H42ZM21 42V36C12.7157 36 6 29.2843 6 21H0H-6C-6 35.9117 6.08831 48 21 48V42ZM0 21H6C6 12.7157 12.7157 6 21 6V0V-6C6.08831 -6 -6 6.08831 -6 21H0ZM21 0V6C29.2843 6 36 12.7157 36 21H42H48C48 6.08831 35.9117 -6 21 -6V0Z",
    mask: "url(#path-1-inside-1_117_2591)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.81f5ee0607b399a6db5ce97f6b7ad40f.svg";
export { ForwardRef as ReactComponent };